import { Box } from '@mui/material';

import { ItemAvailabilityStatus } from 'entities/CatalogItem/lib/itemAvailability';
import { Proposal } from 'entities/Proposal/model/types/ProposalSchema';
import { NoSuppliersMessage } from 'shared/ui/ItemAvailabilityModal';
import { SupplierBadgeWithTooltip } from 'shared/ui/Suppliers/ui/SupplierBadgeWithTooltip';

import { PropertyCatalogItemSupplierStatusIcon } from './PropertyCatalogItemSupplierStatusIcon';

interface PropertyCatalogItemSupplierSlotProps {
    availabilityStatus?: ItemAvailabilityStatus;
    proposals: Proposal[];
    onLearnMore?: () => void;
    showCarriedByLabel?: boolean;
}

export const PropertyCatalogItemSupplierSlot = ({
    availabilityStatus,
    proposals,
    onLearnMore,
    showCarriedByLabel = false,
}: PropertyCatalogItemSupplierSlotProps) => {
    if (availabilityStatus === ItemAvailabilityStatus.NO_SUPPLIERS) {
        return (
            <Box sx={{ marginTop: '4px', flex: '1 1 auto', minWidth: 0 }}>
                <NoSuppliersMessage />
            </Box>
        );
    }

    const isSuppliersNotEnabled =
        availabilityStatus === ItemAvailabilityStatus.SUPPLIERS_NOT_ENABLED;
    const isCountLabel = proposals.length > 1;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-end',
                gap: '6px',
                maxWidth: '100%',
                ...(isCountLabel
                    ? { flex: '0 0 auto' }
                    : {
                          flex: '1 1 160px',
                          minWidth: 'min(160px, 100%)',
                      }),
            }}
        >
            <SupplierBadgeWithTooltip
                fullProposals={proposals}
                showCarriedByLabel={showCarriedByLabel}
                dimmed={isSuppliersNotEnabled}
                trailing={
                    isSuppliersNotEnabled ? (
                        <Box sx={{ flexShrink: 0, display: 'flex' }}>
                            <PropertyCatalogItemSupplierStatusIcon
                                availabilityStatus={availabilityStatus}
                                proposals={proposals}
                                onLearnMore={onLearnMore}
                            />
                        </Box>
                    ) : null
                }
            />
        </Box>
    );
};
